import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import APICall from "./apiCall.js";
import { getPanelToken } from "./auth/AuthActions.js";

import NOTIFICATION_TYPES from "../../../../../server.common/NotificationTypes.js";
import { formatUTCString } from "../../dateutils.js";

export const DEFAULT_START_DATE = new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split("T")[0];
export const DEFAULT_END_DATE = (new Date()).toISOString().split("T")[0];

const notificationsEntity = createEntityAdapter({
    selectId: ({ id }) => id,
});

const entitySelectors = notificationsEntity.getSelectors( state => state.notifications);

export const notificationsSlice = createSlice({
    name: "notifications",
    initialState: notificationsEntity.getInitialState(),

    reducers: {
        clear: notificationsEntity.removeAll,
        loadNotifications: notificationsEntity.setAll,
        appendNotifications: notificationsEntity.setMany
        
    },
});

// actions

export const loadNotifications = () => {

    return async dispatch => {
        await dispatch(getPanelToken());
        const data = await APICall("/notifications/list", null, null, "claims")
        dispatch(notificationsSlice.actions.loadNotifications(data));
    }
}

export const appendNotifications = notificationsSlice.actions.appendNotifications;
// Selectors

export const selectNotifications = (hwaddr) => state => {
    return entitySelectors
        .selectAll(state)
        .filter( e => (e.hwaddr == hwaddr) )
        .sort( (a, b) => a.created_at.localeCompare(b.created_at));
}

export const getNotificationCount = (hwaddr) => state => selectNotifications(hwaddr)(state).length;

export const useNotificationsBasedOnRouter = () => {
    const { hwaddr } = useParams();
    const dispatch = useDispatch();

    useEffect(() =>{
        dispatch( loadNotifications())
    }, [hwaddr])

    return useSelector(
        selectNotifications(hwaddr)
    );
}


export function getNotificationTitle(n) {
    if (n.notification_type == NOTIFICATION_TYPES.TIME_DESYNC) {
        return "Panel time possibly out of sync";
    }

    return `Unknown notification with id ${n.id}`;
}

export function getNotificationDescription(n) {
    if (n.notification_type == NOTIFICATION_TYPES.TIME_DESYNC) {
        return `An event was received at ${formatUTCString(n.notification_data.recorded_time)}, with a panel reported time of ${formatUTCString(n.notification_data.panel_time)} `;
    }
    return `Unable to explain (${JSON.stringify(n)})`;
}

export function markNotificationResolved(id) {
    return dispatch => dispatch(getPanelToken()).then( () => APICall(`/notifications/${id}/resolve`, {}, {}, "claims"));
}

export default notificationsSlice.reducer;
